export const BASE_URL = "http://localhost:8081"; // Adjust with your actual backend URL

export const Signin = `${BASE_URL}/auth/signin`;
export const U_Signup = `${BASE_URL}/user/save`;
export const ForgotPassword = `${BASE_URL}/forgot/save`;
export const ACCOUNT_SAVE = `${BASE_URL}/account/save`;
export const ACCOUNT_GET = `${BASE_URL}/account/get`;
export const PAYMENT_SAVE = `${BASE_URL}/payment/save`;
export const PAYMENT_GET = `${BASE_URL}/payment/get`;
export const PAYMENT_CHART_MONTHLY = "/api/payment-chart/monthly";
export const PAYMENT_CHART_WEEKLY = "/api/payment-chart/weekly";



